import apiGd from "./apiGd";

const getAuthConfig = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

function stripCnpj(cnpj) {
  if (!cnpj) return cnpj;
  return cnpj.replace(/[.\-/]/g, "");
}

export async function getBrands(restaurantId, token) {
  const response = await apiGd.get(
    `/admin/restaurants/${restaurantId}/brands`,
    getAuthConfig(token)
  );
  return response.data;
}

export async function createBrand(restaurantId, data, token) {
  const response = await apiGd.post(
    `/admin/restaurants/${restaurantId}/brands`,
    { ...data, cnpj: stripCnpj(data.cnpj) },
    getAuthConfig(token)
  );
  return response.data;
}

export async function updateBrand(brandId, data, token) {
  const response = await apiGd.put(
    `/admin/brands/${brandId}`,
    { ...data, cnpj: stripCnpj(data.cnpj) },
    getAuthConfig(token)
  );
  return response.data;
}

export async function deleteBrand(brandId, token) {
  await apiGd.delete(`/admin/brands/${brandId}`, getAuthConfig(token));
}

// Torna a marca a padrão do restaurante (define o CNPJ fiscal usado).
// Backend desmarca a padrão antiga e garante que esta fique ativa.
export async function setDefaultBrand(brandId, token) {
  const response = await apiGd.put(
    `/admin/brands/${brandId}`,
    { is_default: true },
    getAuthConfig(token)
  );
  return response.data;
}

export async function uploadBrandImage(file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiGd.post("admin/files", formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}
